import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 800px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 16px;
  padding: 40px;
  backdrop-filter: blur(10px);
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
  h3 { margin: 0 0 10px; color: var(--text-primary); font-size: 24px; }
  p { margin: 0; color: var(--text-muted); }
`;

const Steps = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 20px;
    left: 40px;
    right: 40px;
    height: 4px;
    background: var(--glass-border);
    z-index: 1;
  }

  @media(max-width: 600px) {
    flex-direction: column;
    gap: 30px;
    &::before {
      top: 0; left: 20px; bottom: 0; width: 4px; height: auto;
    }
  }
`;

const StepItem = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100px;

  @media(max-width: 600px) {
    flex-direction: row;
    width: 100%;
    text-align: left;
  }
`;

const Circle = styled.div`
  width: 44px;
  height: 44px;
  background: ${props => props.active ? 'var(--accent)' : 'var(--glass-2)'};
  border: ${props => props.active ? 'rgba(255,255,255,0.2)' : 'var(--glass-border)'} solid 2px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.active ? '#fff' : 'var(--text-muted)'};
  font-weight: bold;
  margin-bottom: 15px;
  box-shadow: ${props => props.active ? '0 0 15px var(--accent-glow)' : 'none'};
  transition: all 0.3s;

  svg { width: 20px; height: 20px; }

  @media(max-width: 600px) {
    margin-bottom: 0;
    margin-right: 20px;
    flex-shrink: 0;
  }
`;

const Label = styled.div`
  font-size: 14px;
  color: ${props => props.active ? 'var(--text-primary)' : 'var(--text-muted)'};
  font-weight: ${props => props.active ? 'bold' : 'normal'};
`;

const DateText = styled.div`
  font-size: 11px;
  color: var(--accent);
  margin-top: 5px;
  opacity: ${props => props.active ? 1 : 0};
`;

const OrderTrackerWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <Header>
        <h3>{node.content?.title || 'Bestellstatus: W10293848'}</h3>
        <p>{node.content?.subtitle || 'Voraussichtliche Lieferung: Morgen, 10:00 - 13:00 Uhr'}</p>
      </Header>

      <Steps>
        <StepItem>
          <Circle active={true}>✓</Circle>
          <div>
            <Label active={true}>Bestellt</Label>
            <DateText active={true}>12. Okt</DateText>
          </div>
        </StepItem>
        <StepItem>
          <Circle active={true}>📦</Circle>
          <div>
            <Label active={true}>Verpackt</Label>
            <DateText active={true}>13. Okt</DateText>
          </div>
        </StepItem>
        <StepItem>
          <Circle active={true}>🚚</Circle>
          <div>
            <Label active={true}>Unterwegs</Label>
            <DateText active={true}>Heute, 08:30</DateText>
          </div>
        </StepItem>
        <StepItem>
          <Circle active={false}>🏠</Circle>
          <div>
            <Label active={false}>Zugestellt</Label>
            <DateText active={false}>-</DateText>
          </div>
        </StepItem>
      </Steps>
      
      <div style={{marginTop: 40, textAlign:'center'}}>
        <button className="tef-bubbles" style={{background:'var(--glass-2)', border:'1px solid var(--glass-border)', color:'var(--text-primary)', padding:'10px 20px', borderRadius:'8px', cursor:'pointer'}}>Sendungsverfolgung DHL</button>
      </div>
    </Wrapper>
  );
};

registry.register('order_tracker', {
  label: 'Bestellstatus',
  icon: '📦',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: OrderTrackerWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Kopfbereich', fields: [{name:'content.title', label:'Bestellnummer', type:'text'}, {name:'content.subtitle', label:'Lieferinfo', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}, {name:'style.desktop.width', label:'Breite', type:'text'}] }] }
  ]
});
